import { render } from "./ConfiguratorTablist.vue?vue&type=template&id=a533747e"
import script from "./ConfiguratorTablist.vue?vue&type=script&lang=js"
export * from "./ConfiguratorTablist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__